import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, ViewChild } from '@angular/core';
import {  findElementByParent, findElementByTagName } from '../../helpers/element.helper';
import { PopoverDirection } from './popover-direction.enum';
import { onClose } from './on-close.model';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent implements OnInit {

  @Input() isOpen = false;
  @Input() width: string;
  @Input() height: string;
  @Input() diretion: PopoverDirection = PopoverDirection.down;

  @Input() parent: Element;

  @Output() onOpen = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<onClose>();

  @ViewChild('content', {read: ElementRef}) contentRef: ElementRef;
  @ViewChild('triangle', {read: ElementRef}) triangleRef: ElementRef;

  constructor(private renderer: Renderer2,
    public element: ElementRef) { }

  ngOnInit() {
    this.setEventsListener();

    this.changeContentAtributtes();
  }

  changeContentAtributtes() {
    const elm = this.contentRef.nativeElement;

    if (elm != null) {

      if (this.width) {
        this.renderer.setStyle(elm, 'width', this.width);
      }

      if (this.height) {
        this.renderer.setStyle(elm, 'height', this.height);
      }
    }
  }

  setEventsListener() {
    this.renderer.listen(document.body, 'click', (event) => {
      if (this.isOpen) {
        const classList = event.target.classList;
        const elm =  this.findValidElement(event, classList);

        if (!elm) {
          this.close();
        }
      }
    });
  }

  private findValidElement(event: any, classList: any): any {
    return findElementByParent(event.target, this.parent) ||
      findElementByParent(event.target, this.element.nativeElement) ||
      findElementByTagName(event.target, 'rte-option') ||
      (classList &&
        (typeof classList.find === 'function' && classList.find(x => x === 'cdk-overlay-backdrop') != null) ||
        (classList as DOMTokenList).value.includes('cdk-overlay-backdrop')
      );
  }

  close() {
    const close = new onClose();
    this.onClose.emit(close);
  }

  getParentTagName() {
    const elm = this.parent;
    return elm != null ? elm.parentElement.tagName : null;
  }

}
